import { render, staticRenderFns } from "./TecInfoProjectBrife.vue?vue&type=template&id=5bcbc238&scoped=true&"
import script from "./TecInfoProjectBrife.vue?vue&type=script&lang=js&"
export * from "./TecInfoProjectBrife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbc238",
  null
  
)

export default component.exports